import React, { FC } from 'react';
import Button from 'components/antd/Button';

import SuccessIcon from 'components/common/Icons/SuccessIcon';
import ErrorIcon from 'components/common/Icons/ErrorIcon';

import { MessageTypes } from './config';

import styles from './styles.module.scss';

interface IMessageProps {
    title: string;
    description: string;
    buttonText?: string;
    onClick?: () => void;
    buttonSize?: 'large' | 'small' | 'middle';
    type: MessageTypes;
}

const Message: FC<IMessageProps> = ({ title, description, buttonText, onClick, type, buttonSize }: IMessageProps) => (
    <div className={styles.wrapper}>
        {type === MessageTypes.Success ? <SuccessIcon /> : <ErrorIcon />}
        <div>
            <span>{title}</span>
            <p>{description}</p>
        </div>

        {buttonText && onClick && (
            <Button type='primary' onClick={onClick} size={buttonSize}>
                {buttonText}
            </Button>
        )}
    </div>
);

export default Message;
